import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LayoutComponent } from './layout';
import { HomeComponent } from './home';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { BasicAuthInterceptor, ErrorInterceptor } from '../_helpers';

import { NumericDirective } from "../_directives";
import { GroupByPipe } from '../_pipes';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ChartsModule } from 'ng2-charts';
import { NgSelectModule } from '@ng-select/ng-select';

import { ProfileComponent } from './profile/profile.component';
import { KeywordDetailComponent } from './keyword/keyword-detail/keyword-detail.component';
import { KeywordListComponent } from './keyword/keyword-list/keyword-list.component';
import { AffiliateListComponent } from './keyword/affiliate-list/affiliate-list.component';
import { AffiliateDetailComponent } from './keyword/affiliate-detail/affiliate-detail.component';
import { MoRecordComponent } from './mo-record/mo-record.component';
import { DnRecordComponent } from './dn-record/dn-record.component';
import { DnChargeComponent } from './report/dn-charge/dn-charge.component';
import { DnPerformanceComponent } from './report/dn-performance/dn-performance.component';
import { SubscriptionPerformanceComponent } from './report/subscription-performance/subscription-performance.component';
import { RetentionComponent } from './report/retention/retention.component';
import { MoQualityAssessmentComponent } from './report/mo-quality-assessment/mo-quality-assessment.component';
import { SubscriberComponent } from './subscriber/subscriber.component';
import { MoLogComponent } from './mo-log/mo-log.component';
import { DnLogComponent } from './dn-log/dn-log.component';
import { ClientSubscriberComponent } from './subscriber-client/subscriber.component';
import { ClientMoLogComponent } from './mo-log-client/mo-log.component';
import { ClientDnLogComponent } from './dn-log-client/dn-log.component';
import { ClientsComponent } from './clients/clients.component';
import { GrantComponent } from './clients/grant/grant.component';
import { ContentListComponent, ContentDetailComponent, EpisodeListComponent, EpisodeDetailComponent } from './tx-content';
import { TxKeywordListComponent, TxKeywordDetailComponent } from './tx-keyword';
import { ScMsgListComponent, ScMsgDetailComponent, KwMsgListComponent, KwMsgDetailComponent } from './tx-message';
import { ScheduleSupportComponent, TxKeywordSupportComponent, MsgTemplateSupportComponent, ResourceSupportComponent, ThirdPartyNotesSupportComponent } from './support';
import { from } from 'rxjs';
import { TxMoLogComponent } from './tx-mo-log';
import { TxMtLogComponent } from './tx-mt-log';
import { TxSubscriberComponent } from './tx-subscriber';
import { SmsCountComponent } from './report/sms-count/sms-count.component';
import { StreamHistoryComponent, StreamHistoryReportComponent, StreamKeywordDetailComponent, StreamKeywordGuideComponent, StreamKeywordListComponent } from './stream';
import { DnChargeScComponent, MultipleSubComponent, SubscriptionPerformanceDetailComponent, SummaryScheduleListComponent, } from './report';
import { KeywordAdvanceComponent } from './keyword';
import { SpiderAccountDetailComponent, SpiderAcountListComponent, SpiderScheduleListComponent } from './spider';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { PremiumServiceMetaListComponent } from './premium-service';
import { DnRevenueCompatibleComponent, DnRevenueComponent, PayoutReportComponent, PayoutUploadComponent, RevenueShareRatioComponent } from './revenue';
import { PayoutRecordListComponent } from './revenue/payout/records-list/payout-record-list.component';
import { AdvertiserAffiliateDetailComponent, AdvertiserAffiliateListComponent, AdvertiserDetailComponent, AdvertiserListComponent, OfferStreamHistoryComponent } from './offer-stream';

@NgModule({
  declarations: [
    NumericDirective,
    GroupByPipe,
    LayoutComponent,
    HomeComponent,
    ProfileComponent,
    KeywordDetailComponent,
    KeywordListComponent,
    KeywordAdvanceComponent,
    AffiliateListComponent,
    AffiliateDetailComponent,
    MoRecordComponent,
    DnRecordComponent,
    DnChargeComponent,
    DnPerformanceComponent,
    DnRevenueComponent,
    DnRevenueCompatibleComponent,
    SubscriptionPerformanceComponent,
    SubscriptionPerformanceDetailComponent,
    RetentionComponent,
    MoQualityAssessmentComponent,
    SubscriberComponent,
    MoLogComponent,
    DnLogComponent,
    ClientSubscriberComponent,
    ClientMoLogComponent,
    ClientDnLogComponent,
    ClientsComponent,
    GrantComponent,
    ContentListComponent,
    ContentDetailComponent,
    EpisodeListComponent,
    EpisodeDetailComponent,
    TxKeywordListComponent,
    TxKeywordDetailComponent,
    ScMsgListComponent,
    ScMsgDetailComponent,
    KwMsgListComponent,
    KwMsgDetailComponent,
    ScheduleSupportComponent,
    TxKeywordSupportComponent,
    MsgTemplateSupportComponent,
    ResourceSupportComponent,
    TxMoLogComponent,
    TxMtLogComponent,
    TxSubscriberComponent,
    ThirdPartyNotesSupportComponent,
    SmsCountComponent,
    StreamKeywordGuideComponent,
    StreamKeywordListComponent,
    StreamKeywordDetailComponent,
    StreamHistoryComponent,
    StreamHistoryReportComponent,
    MultipleSubComponent,
    DnChargeScComponent,
    SpiderAcountListComponent,
    SpiderAccountDetailComponent,
    SpiderScheduleListComponent,
    SummaryScheduleListComponent,
    PremiumServiceMetaListComponent,
    PayoutUploadComponent,
    PayoutReportComponent,
    RevenueShareRatioComponent,
    PayoutRecordListComponent,

    AdvertiserListComponent,
    AdvertiserDetailComponent,
    AdvertiserAffiliateListComponent,
    AdvertiserAffiliateDetailComponent,
    OfferStreamHistoryComponent,
  ],
  imports: [
    CommonModule,
    NgbModule,
    NgSelectModule,
    PaginationModule.forRoot(),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    DashboardRoutingModule,
    AngularMultiSelectModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

    // provider used to create fake backend
    // fakeBackendProvider
  ]
})
export class DashboardModule { }
